import path from 'node:path'
import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import { resolveCliAssetPath } from '@cli-utils/paths.js'
import { applyAdminNamespaceToContent } from '@next-adapter/config/namespace/apply-admin-namespace-to-content.js'
import { applyAdminNamespaceToPath } from '@next-adapter/config/namespace/apply-admin-namespace-to-path.js'
import fs from 'fs-extra'
import { copyStaticComponentTemplatesRecursive } from './copy-static-component-templates-recursive.js'

export function copyStaticComponentTemplates(
  cwd: string,
  config: ResolvedBetterstartConfig,
  sourceDirectory: 'ui' | 'custom',
  targetDirectory: 'ui' | 'custom'
): string[] {
  const created: string[] = []
  const destDir = path.resolve(cwd, config.paths.admin, 'components', targetDirectory)

  const srcDir = resolveCliAssetPath('shared-assets', 'react-admin', sourceDirectory)

  if (!fs.existsSync(srcDir)) {
    return created
  }

  fs.ensureDirSync(destDir)

  if (sourceDirectory === 'custom') {
    copyStaticComponentTemplatesRecursive(
      srcDir,
      destDir,
      '',
      path.join(config.paths.admin, 'components', targetDirectory),
      config.frameworkConfig.next.namespace,
      created
    )
    return created
  }

  const files = fs
    .readdirSync(srcDir, { withFileTypes: true })
    .filter(
      (entry) => entry.isFile() && (entry.name.endsWith('.tsx') || entry.name.endsWith('.ts'))
    )
    .map((entry) => entry.name)

  for (const file of files) {
    const namespacedFile = applyAdminNamespaceToPath(file, config.frameworkConfig.next.namespace)
    const destPath = path.join(destDir, namespacedFile)
    if (!fs.existsSync(destPath)) {
      const content = fs.readFileSync(path.join(srcDir, file), 'utf-8')
      fs.writeFileSync(
        destPath,
        applyAdminNamespaceToContent(content, config.frameworkConfig.next.namespace),
        'utf-8'
      )
      created.push(path.join(config.paths.admin, 'components', targetDirectory, namespacedFile))
    }
  }

  return created
}
